module.exports = __webpack_public_path__ + "img/living.4704536e.png";